import { Component, Input, OnInit } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/pro-regular-svg-icons';

export enum InlineInfoTypes {
  INFO = 'info',
  ALERT = 'alert',
  WARNING = 'warning',
}

/**
 * Component to display content inline with an icon attached to it to indicate the type of information.
 */
@Component({
  standalone: true,
  selector: 'ct-lib-inline-info',
  templateUrl: './inline-info.component.html',
  styleUrls: ['./inline-info.component.scss'],
  imports: [FaIconComponent],
  host: {
    class: 'd-flex align-items-center mt-3 mb-4',
  },
})
export class InlineInfoComponent implements OnInit {
  @Input() type: InlineInfoTypes = InlineInfoTypes.INFO;
  @Input() infoIconAccentColor: string;
  faInfoCircle = faInfoCircle;
  faExclamationCircle = faExclamationCircle;
  faExclamationTriangle = faExclamationTriangle;

  

  ngOnInit(): void {}
}
